export const mockData = {
  hero: {
    headline: "Professional Websites Built to Help Local Businesses Grow",
    subheadline: "Fast, mobile-friendly websites designed to generate more enquiries, bookings and sales.",
    ctaText: "Get My Free Website Preview",
    secondaryCta: "View Example Projects",
    trustBadges: [
      "Based in London",
      "Fast turnaround",
      "Affordable pricing"
    ]
  },
  whyChoose: [
    {
      id: 1,
      title: "Fast Delivery",
      description: "Most websites completed within 5–7 days.",
      icon: "zap"
    },
    {
      id: 2,
      title: "Built for Local Businesses",
      description: "Designed to generate more enquiries, bookings and sales.",
      icon: "target"
    },
    {
      id: 3,
      title: "No Hidden Costs",
      description: "Transparent pricing, responsive support and clear communication.",
      icon: "check-circle"
    }
  ],
  whatsIncluded: [
    { id: 1, title: "Mobile Responsive", icon: "smartphone" },
    { id: 2, title: "Contact Form", icon: "mail" },
    { id: 3, title: "Google Maps Integration", icon: "map-pin" },
    { id: 4, title: "SEO Optimised", icon: "search" },
    { id: 5, title: "Fast Loading", icon: "zap" },
    { id: 6, title: "SSL Secure", icon: "shield" },
    { id: 7, title: "WhatsApp Integration", icon: "message-circle" },
    { id: 8, title: "Google Reviews", icon: "star" },
    { id: 9, title: "Modern Design", icon: "layout" },
    { id: 10, title: "Easy Contact Forms", icon: "check-circle" }
  ],
  process: [
    { id: 1, title: "Tell us about your business", description: "Share your business goals and requirements", icon: "message-square" },
    { id: 2, title: "We design your website", description: "Our team creates a custom design for you", icon: "palette" },
    { id: 3, title: "You review everything", description: "Give feedback and request any changes", icon: "eye" },
    { id: 4, title: "We launch your website", description: "Your new website goes live", icon: "rocket" }
  ],
  trustedIndustries: [
    "Plumbing",
    "Roofing", 
    "Hair Salons",
    "Gyms",
    "Restaurants",
    "Cleaning Services",
    "Beauty Clinics",
    "Car Detailing"
  ],
  contact: {
    email: "meshweb.co@gmail.com",
    phone: "+44 7543917115",
    phoneDisplay: "+44 7543 917115",
    location: "London, UK"
  },
  services: [
    {
      id: 1,
      title: "Website Design for Local Businesses",
      description: "Custom professional websites built specifically for local service businesses to attract more enquiries and customers online.",
      icon: "layout"
    },
    {
      id: 2,
      title: "Mobile Responsive Website Development",
      description: "Websites designed to work perfectly on phones, tablets, and desktops so customers can easily browse and contact you.",
      icon: "smartphone"
    },
    {
      id: 3,
      title: "Website Redesign and Modernization",
      description: "Upgrade outdated websites into modern, professional designs that build trust and improve your online presence.",
      icon: "refresh-cw"
    },
    {
      id: 4,
      title: "Contact Forms & Lead Generation",
      description: "Easy-to-use contact forms that allow customers to quickly send enquiries or booking requests.",
      icon: "mail"
    },
    {
      id: 5,
      title: "Google Maps Integration",
      description: "Help customers easily find your business location with built-in Google Maps integration.",
      icon: "map-pin"
    },
    {
      id: 6,
      title: "SEO-Friendly Website Structure",
      description: "Websites built with proper structure to help you rank better on Google search results.",
      icon: "search"
    }
  ],
  portfolio: [
    {
      id: 1,
      title: "ClearCuts ELBS",
      description: "Modern barber shop website with online booking, service pricing, haircut gallery, and Google Maps location integration. Designed to help local customers quickly book appointments.",
      images: [
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/yihlp6lg_Screenshot%202026-03-07%20at%2000.54.05.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/39sk8r3e_Screenshot%202026-03-07%20at%2000.54.44.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/fdst42ur_Screenshot%202026-03-07%20at%2000.55.07.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/rv34t58l_Screenshot%202026-03-07%20at%2000.55.28.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/nj5ozwwb_Screenshot%202026-03-07%20at%2000.58.29.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/xl1q7cy9_Screenshot%202026-03-07%20at%2000.58.56.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/wc4yujhg_Screenshot%202026-03-07%20at%2000.59.32.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/538gltl8_Screenshot%202026-03-07%20at%2000.59.41.png"
      ],
      category: "Barber Shop",
      demoUrl: "#barber-demo"
    },
    {
      id: 2,
      title: "Anytime Detailers",
      description: "Professional car detailing website with service packages, before and after gallery, online booking form, and Google Maps integration.",
      images: [
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/qehygo55_Screenshot%202026-03-06%20at%2021.51.00.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/zi3q42ov_Screenshot%202026-03-06%20at%2021.46.53.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/j3mujmtn_Screenshot%202026-03-06%20at%2021.47.34.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/mg891j0l_Screenshot%202026-03-06%20at%2021.48.02.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/o2tz3sq8_Screenshot%202026-03-06%20at%2021.48.29.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/06003zoq_Screenshot%202026-03-06%20at%2021.49.01.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/lwm6c8r4_Screenshot%202026-03-06%20at%2021.49.23.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/k8rq9fll_Screenshot%202026-03-06%20at%2021.49.39.png"
      ],
      category: "Car Detailing",
      demoUrl: "#detailing-demo"
    },
    {
      id: 3,
      title: "Shoreditch FC",
      description: "High-energy gym website with membership sign-up, trainer profiles, class schedules, and a modern landing page designed to attract new members.",
      images: [
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/z8w9oneq_Screenshot%202026-03-06%20at%2023.29.39.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/bmacn6qh_Screenshot%202026-03-06%20at%2023.33.41.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/w2kh3rb6_Screenshot%202026-03-06%20at%2023.34.01.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/dtkwuc68_Screenshot%202026-03-06%20at%2023.34.21.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/v4ruakg4_Screenshot%202026-03-06%20at%2023.35.05.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/u73qdo6g_Screenshot%202026-03-06%20at%2023.35.24.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/2z8vmaxy_Screenshot%202026-03-06%20at%2023.38.56.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/301phsbm_Screenshot%202026-03-06%20at%2023.39.26.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/47ecwkmt_Screenshot%202026-03-06%20at%2023.40.42.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/t4tqe28c_Screenshot%202026-03-06%20at%2023.41.04.png"
      ],
      category: "Fitness Gym",
      demoUrl: "#gym-demo"
    },
    {
      id: 4,
      title: "MPS Roofing",
      description: "Professional roofing company website featuring service pages, emergency contact options, project gallery of previous roof work, and a quick quote enquiry form.",
      images: [
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/djj3shvo_Screenshot%202026-03-06%20at%2021.36.00.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/m9t2ytpl_Screenshot%202026-03-06%20at%2021.37.25.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/dl3shq93_Screenshot%202026-03-06%20at%2021.38.00.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/kfx2cxhc_Screenshot%202026-03-06%20at%2021.38.31.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/slbl106e_Screenshot%202026-03-06%20at%2021.38.55.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/9vifo3pg_Screenshot%202026-03-06%20at%2021.39.28.png",
        "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/fafdb3k0_Screenshot%202026-03-06%20at%2021.39.45.png"
      ],
      category: "Roofing Service",
      demoUrl: "#roofing-demo"
    }
  ],
  whyWorkWithMe: [
    {
      id: 1,
      title: "Fast Turnaround",
      description: "Your website designed and launched quickly so your business can start attracting customers sooner.",
      icon: "zap"
    },
    {
      id: 2,
      title: "Clean Modern Design",
      description: "A professional design that builds trust and helps your business stand out online.",
      icon: "sparkles"
    },
    {
      id: 3,
      title: "Mobile Optimised",
      description: "Your website will look perfect on phones, tablets, and desktops.",
      icon: "monitor-smartphone"
    },
    {
      id: 4,
      title: "Built for Local Businesses",
      description: "Designed specifically for service businesses that rely on local customers.",
      icon: "target"
    }
  ],
  pricing: [
    {
      id: 1,
      title: "Starter Website",
      price: "£350",
      period: "one-time",
      popular: false,
      features: [
        "Up to 3 Pages",
        "Mobile Responsive",
        "Contact Form",
        "Basic SEO",
        "7-Day Delivery"
      ]
    },
    {
      id: 2,
      title: "Business",
      price: "£450",
      period: "one-time",
      popular: true,
      features: [
        "5–7 pages",
        "Contact form",
        "Google Reviews",
        "Gallery",
        "FAQ",
        "Google Map",
        "Mobile responsive"
      ]
    },
    {
      id: 3,
      title: "Premium",
      price: "£650",
      period: "one-time",
      popular: false,
      features: [
        "Everything in Business plus:",
        "Before & after slider",
        "Online quote calculator",
        "Live WhatsApp chat",
        "Advanced animations",
        "More service pages",
        "SEO optimisation",
        "Speed optimisation",
        "Monthly analytics setup",
        "Priority edits after launch"
      ]
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Local Service Business Owner",
      text: "Fast and easy to work with. The website looks really professional and we've already had enquiries through it.",
      role: "Business Owner",
      label: "Client Feedback"
    },
    {
      id: 2,
      name: "Plumbing Company Owner",
      text: "Our old website looked outdated. The new one is clean, modern, and much easier for customers to use.",
      role: "Business Owner",
      label: "Client Feedback"
    }
  ],
  processDetailed: [
    {
      id: 1,
      step: "Step 1",
      title: "Quick Chat About Your Business",
      description: "We discuss your business, services, and what you want your website to achieve."
    },
    {
      id: 2,
      step: "Step 2",
      title: "Design Preview",
      description: "You receive a homepage preview so you can see the layout and style before the full website is built."
    },
    {
      id: 3,
      step: "Step 3",
      title: "Website Build & Launch",
      description: "Once approved, your full website is built and launched so customers can start finding you online."
    }
  ],
  portfolioFeatures: {
    1: ["Online booking system", "Service pricing page", "Haircut gallery"],
    2: ["Service packages", "Before & after gallery", "Online booking form"],
    3: ["Membership sign-up", "Trainer profiles", "Class schedules"],
    4: ["Service pages", "Emergency contact", "Project gallery"]
  },
  results: [
    {
      id: 1,
      business: "Car Detailing Business",
      before: ["Only Instagram page", "No online booking"],
      after: ["Professional website", "Online enquiry form"],
      result: "Easier customer enquiries and a more professional online presence."
    },
    {
      id: 2,
      business: "Roofing Company",
      before: ["Outdated website", "Hard to contact"],
      after: ["Clean modern website", "Clear services and contact form"],
      result: "More trust from potential customers."
    }
  ],
  about: {
    title: "About MeshWeb",
    description1: "MeshWeb helps local businesses create modern websites that attract customers and build trust online.",
    description2: "We focus on clean design, mobile-friendly layouts, and simple websites that make it easy for customers to contact your business."
  },
  faq: [
    {
      id: 1,
      question: "Do I own my website?",
      answer: "Yes. The website is built specifically for your business and all of your business content belongs to you. MeshWeb professionally hosts and maintains the website to keep it secure, fast and online."
    },
    {
      id: 2,
      question: "Is there a monthly fee?",
      answer: "Yes. After the one-time website build fee, there is a £25/month Website Care Plan. This keeps your website live and includes secure hosting, SSL certificate, backups, security monitoring, technical maintenance and ongoing support."
    },
    {
      id: 3,
      question: "What does the £25/month include?",
      answer: "Your Website Care Plan includes: Secure website hosting, SSL certificate (HTTPS), Website backups, Security updates, Contact form monitoring, Technical support, Minor text and image updates, and Performance monitoring."
    },
    {
      id: 4,
      question: "Can I cancel the monthly plan?",
      answer: "Yes. You can cancel with notice. If the Website Care Plan is cancelled, the website will no longer be hosted or maintained by MeshWeb and may no longer be available online unless alternative hosting is arranged."
    },
    {
      id: 5,
      question: "How long does it take to build my website?",
      answer: "Most websites are completed within 5–10 business days, depending on the size of the project and how quickly we receive your content."
    },
    {
      id: 6,
      question: "Can I request changes after launch?",
      answer: "Absolutely. Minor text and image updates are included as part of the Website Care Plan. Larger redesigns or additional features may require a separate quote."
    },
    {
      id: 7,
      question: "Will my website work on phones and tablets?",
      answer: "Yes. Every website is fully responsive and optimised for desktop, tablet and mobile devices."
    },
    {
      id: 8,
      question: "Can you redesign my current website?",
      answer: "Yes. We can redesign your existing website with a modern, mobile-friendly design that helps convert more visitors into customers."
    },
    {
      id: 9,
      question: "Can you help with my domain and Google Business Profile?",
      answer: "Yes. We can connect your custom domain, configure your website, and help link it to your Google Business Profile so customers can easily find your website from Google Search and Maps."
    }
  ],
  caseStudies: [
    {
      id: 1,
      client: "East London Barber Studio",
      industry: "Personal Care",
      challenge: "No online presence, relying only on walk-ins",
      solution: "Modern booking website with online appointment system",
      results: [
        { metric: "Online Bookings", value: "150%", description: "increase in monthly appointments" },
        { metric: "New Customers", value: "40%", description: "growth in first-time clients" },
        { metric: "Revenue", value: "£3,200", description: "additional monthly income" }
      ],
      timeframe: "2 weeks",
      testimonial: "The website paid for itself in the first month. We're now fully booked every week!",
      image: "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/yihlp6lg_Screenshot%202026-03-07%20at%2000.54.05.png"
    },
    {
      id: 2,
      client: "London Roofing Specialists",
      industry: "Construction",
      challenge: "Website looked outdated, not getting online leads",
      solution: "Professional redesign with clear service pages and contact forms",
      results: [
        { metric: "Lead Inquiries", value: "200%", description: "increase in contact form submissions" },
        { metric: "Project Value", value: "£15K+", description: "average project from website leads" },
        { metric: "Time Saved", value: "10hrs/week", description: "less time explaining services" }
      ],
      timeframe: "10 days",
      testimonial: "We're getting serious inquiries now, not just tire-kickers. Best investment we've made.",
      image: "https://customer-assets.emergentagent.com/job_meshweb-portfolio/artifacts/djj3shvo_Screenshot%202026-03-06%20at%2021.36.00.png"
    }
  ],
  whatsapp: {
    number: "447543917115", // Your WhatsApp business number
    message: "Hi! I'm interested in a website for my business."
  }
};
